import React, { useState } from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import Input from "aldoo-ra/Input"
import PlatformAuth from "aldoo-ra/PlatformAuth"
import { ChangeUsername } from "aldoo-ra/PlatformAuth/api"
import { showNotification } from "aldoo-ra/Notification"

import useSigninController from "aldoo-ra/Signin/signin-controller"
const { useAuth } = PlatformAuth

const ProfileSettingsCard = () => {
  const auth = useAuth()
  const { userProfile } = useSigninController()




  const [saveMessage, setSaveMessage] = useState("")
  const [errorMessage, setErrorMessage] = useState("")
  const [formData, setFormData] = useState({
    name: userProfile?.name || "",
    email: userProfile?.email || "",
  })

  const handleInputChange = (field) => (e) => {
    setFormData((prev) => ({
      ...prev,
      [field]: e.target.value,
    }))
  }

  const handleSave = async () => {
    try {
      await ChangeUsername(formData.name)
      showNotification({
        message: saveMessage,
        className: "bg-primary text-white",
      })
      // You might want to show a success notification here
    } catch (error) {
      showNotification({
        message: errorMessage,
        className: "bg-error text-text_inv",
      })
    }
  }

  return (
    <CMSRender
      contentType="ProfileSettingsCard"
      renderItem={(card) => {
        setTimeout(() => {
          setSaveMessage(card.save_success)
          setErrorMessage(card.save_error)
        }, 0)
        return (
          <div className="w-full bg-paper rounded-[50px] px-[42px] pt-[36px] pb-[34px] shadow-card_shadow">
            {/* Title */}
            <Typography variant="h3" className="text-text mb-[30px]">
              {card.title}
            </Typography>

            <div className="w-full space-y-[30px]">
              {/* Name Input */}
              <div className="space-y-2">
                <Typography variant="body1_accent" className="text-text my-0">
                  {card.controls[0]}
                </Typography>

                <Input
                  value={formData.name}
                  onChange={handleInputChange("name")}
                  className="w-full h-[56px] rounded-full bg-gray_100 border-bordered-1 text-text"
                  placeholder="Your name"
                />
              </div>

              {/* Email Input */}
              <div className="space-y-2">
                <Typography variant="body1_accent" className="text-text my-0">
                  {card.controls[1]}
                </Typography>

                <Input
                  value={formData.email}
                  onChange={handleInputChange("email")}
                  className="w-full h-[56px] rounded-full bg-gray_100 text-text"
                  placeholder="Billing Email"
                />
              </div>

              {/* Save Button */}
              <div className="pt-4">
                <Button
                  variant="primary_s"
                  className="px-8 py-3 rounded-full"
                  onClick={handleSave}
                >
                  {card.save[0].label}
                </Button>
              </div>
            </div>
          </div>
        )
      }}
    />
  )
}

export default ProfileSettingsCard
